import type { Theme } from '@mui/material/styles'
import type { SystemStyleObject } from '@mui/system'

/** Theme-aware paper surface for outlined / picker inputs. Use in `styled()` and `sx`. */
export const inputPaperSurface = (theme: Theme): SystemStyleObject<Theme> => ({
    '& .MuiOutlinedInput-root, & .MuiPickersOutlinedInput-root, & .MuiPickersInputBase-root':
        {
            backgroundColor: theme.palette.background.paper,
        },
    '& .MuiOutlinedInput-input, & .MuiPickersInputBase-input': {
        backgroundColor: 'transparent',
    },
})
